import { render, staticRenderFns } from "./RequisitionDetail.vue?vue&type=template&id=36f17d02&"
import script from "./RequisitionDetail.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetail.vue?vue&type=script&lang=ts&"
import style0 from "./RequisitionDetail.vue?vue&type=style&index=0&id=36f17d02&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports